import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { ModalBoxComponent } from 'app/shared/components/modalbox/modal-box.component';
import { WarmUpService } from 'app/services/warmup/warmup.service';

import { UserComponent } from '../user/user.component';

import { User } from 'app/shared/models/user.model';

import { UserService } from './../user.service';

@Component({
    selector: 'user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css']
})

/**
 * Component to display the user list.
 */
export class UserListComponent implements OnInit {
    dialogRef: MdDialogRef<any>;
    selectedUser: Object;
    userlist: User[];

    constructor(
        private userService: UserService,
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        public warmUpService: WarmUpService) { }

    ngOnInit() {
        this.userlist = [];
        this.getUserList();
    }

    getUserList() {
        this.userlist = this.warmUpService.getUsersList();
    }

    openUserDetailsDialog(action: string) {
        let config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(UserComponent, config);
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.componentInstance.selectedUser = (action === 'Edit' ? this.selectedUser : null);
        this.dialogRef.afterClosed().subscribe(response => {
            this.dialogRef = null;
            if (response) {
                this.warmUpService.refreshUserList();
                if (action == 'Edit') {
                    for (let index in this.userlist) {
                        if ( this.userlist[index].userId == response.userId) {
                            this.userlist[index] = response;
                        }
                    }
                } else {
                    this.userlist.push(response);
                }
            }
            this.selectedUser = null;
        });
    }

    editUser(value: User): void {
        this.selectedUser = value
        this.openUserDetailsDialog('Edit');
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/userlist/user-list.component.ts